<template>
  <div id="">
    <div class="top-box">
      <el-date-picker
        v-model="monthStr"
        @change="zhibanMonthFun"
        type="month"
        placeholder="选择月"
      >
      </el-date-picker>
      <div class="right-btn">
        <el-button
          @click="downloadFileFun"
          icon="el-icon-download"
          class="search"
          >下载导入模板</el-button
        >
        <el-upload
          class="upload-demo"
          accept=".xlsx"
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="importDataFun"
        >
          <el-button class="other el-icon-upload2">导入值班表</el-button>
        </el-upload>
        <el-button @click="dialogVisible = true" class="search"
          >设置打卡地点</el-button
        >
      </div>
    </div>
    <el-calendar v-model="monthStr">
      <template slot="dateCell" slot-scope="{ date, data }">
        <p :class="data.isSelected ? 'is-selected' : ''">
          {{ data.day.split("-")[2] }}
        </p>
        <div class="person-list">
          <span class="left-label">领班</span>
          <span class="right-value"
            >{{ getLbOrDb(data.day, "领班", "userName") }}-{{
              getLbOrDb(data.day, "领班", "phone")
            }}</span
          >
        </div>
        <div class="person-list">
          <span class="left-label">带班</span>
          <span class="right-value"
            >{{ getLbOrDb(data.day, "带班", "userName") }}-{{
              getLbOrDb(data.day, "带班", "phone")
            }}</span
          >
        </div>
        <div class="person-num">
          <el-popover placement="bottom" width="200" trigger="click">
            <div class="content-box">
              <div class="top">值班人员</div>
              <div
                class="bottom-box"
                v-for="(item, index) in getZbList(data.day)"
                :key="index"
              >
                <div
                  class="left-box-item left-box-item0"
                  :class="`left-box-item${index}`"
                >
                  {{ item.name }}
                </div>
                <div class="right-text">
                  {{ item.userName }}-{{ item.phone }}
                </div>
              </div>
            </div>
            <div class="left-box" slot="reference">
              <div
                v-for="(item, index) in getZbList(data.day)"
                :key="index"
                class="left-box-item"
                :class="`left-box-item${index}`"
                v-if="index < 5"
              >
                {{ item.name }}
              </div>
              <div v-if="getZbList(data.day).length > 5" class="left-box-item5">
                {{ getZbList(data.day).length - 5 }}+
              </div>
            </div>
          </el-popover>

          <div class="right-box">共{{ getZbList(data.day).length }}人值班</div>
        </div>
      </template>
    </el-calendar>
    <fileDialog
      v-if="dialogVisible"
      :dialogVisible.sync="dialogVisible"
      @refreshList="zhibanMonthFun"
    >
    </fileDialog>
  </div>
</template>

<script>
import { downloadFile } from "@/api/systemManagement.js";
import { zhibanMonth, importZhiban } from "@/api/onDutyAndStandBy.js";
import fileDialog from "./fileDialog.vue";
import moment from "moment";
export default {
  name: "",
  components: {
    fileDialog
  },
  data() {
    return {
      monthStr: new Date(),
      dialogVisible: false,
      monthDataAll: []
    };
  },
  mounted() {
    this.zhibanMonthFun();
  },
  methods: {
    // 值班月历
    async zhibanMonthFun() {
      const res = await zhibanMonth({
        monthStr: moment(this.monthStr).format("YYYY-MM")
      });
      this.monthDataAll = res.data.data;
    },

    // 模板下载
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/template/值班月历.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "值班月历.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await importZhiban(formData);
      if (res.data.code == 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.zhibanMonthFun();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    }
    // getLbOrDb(date, type, value) {
    //   console.log(date, type);

    //   let itemTemp = null;
    //   this.monthDataAll.forEach(item => {
    //     if (item.dutyDay == moment(date).format("YYYY-MM-DD")) {
    //       if (item.dutyType == "lb") {
    //         itemTemp = item;
    //       }
    //     }
    //   });
    //   return itemTemp ? itemTemp[value] : "";
    // }
  },
  computed: {
    getLbOrDb() {
      return (date, type, value) => {
        let itemTemp = null;
        this.monthDataAll.forEach(item => {
          if (item.dutyDay == moment(date).format("YYYY-MM-DD")) {
            if (item.dutyType == type) {
              itemTemp = item;
            }
          }
        });
        return itemTemp ? itemTemp[value] : "";
      };
    },
    getZbList() {
      return date => {
        let list = [];
        this.monthDataAll.forEach(item => {
          if (
            item.dutyDay == moment(date).format("YYYY-MM-DD") &&
            item.dutyType == "值班"
          ) {
            list.push({
              ...item,
              name: item.userName ? item.userName.slice(0) : ""
            });
          }
        });
        return list;
      };
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-calendar__header {
  display: none;
}
.person-list {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 4px;
  .left-label {
    color: #92979c;
    margin-right: 12px;
  }
  .right-value {
    color: #494c4f;
  }
}
.person-num {
  font-size: 14px;
  color: #92979c;
  display: flex;
  align-items: center;
  margin-top: 12px;
  .left-box {
    display: flex;
    align-items: center;
    margin-right: 8px;
  }
}
.left-box-item {
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 13px;
  color: #ffffff;
  border-radius: 50%;
  background: #0495ff;
  border: 1px solid #ffffff;
  margin-left: -8px;
}
.left-box-item0 {
  margin-left: 0;
}
.left-box-item1 {
  background: #4071d8;
}
.left-box-item2 {
  background: #169e9a;
}
.left-box-item3 {
  background: #c155ff;
}
.left-box-item4 {
  background: #ff8b46;
}
.left-box-item5 {
  background: #655ad0;
}
/deep/.el-calendar-day {
  height: auto;
  padding: 16px;
  padding-top: 6px;
}
.top-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}
.el-button,
.el-button:hover {
  height: 40px;
  font-size: 16px;
  font-size: 16px;
  color: #ffffff;
  background-color: #3666ea;
  margin-right: 12px;
}
.right-btn {
  display: flex;
}
/deep/.el-upload__input {
  display: none;
}
.content-box {
  .top {
    font-weight: 600;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.88);
    line-height: 22px;
    margin-bottom: 12px;
  }
  .bottom-box {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    .right-text {
      font-size: 14px;
      color: #494c4f;
      margin-left: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/onDuty/page.vue